var _Path, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgCheckCircleSolid(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#check-circle-solid_svg__clip0_17418_8011)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M10.75 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    fill: props.color
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M7.625 10.625L9.5 12.5l4.375-4.375",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "check-circle-solid_svg__clip0_17418_8011"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(.75)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgCheckCircleSolid;